var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailableWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.725586,
    height: 16.73761,
    viewBox: "0 0 16.7256 16.7376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 313",
    d: "",
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 313",
    d: "M0.63 6.93C1.29 3.35 4.33 0.68 7.97 0.5C11.61 0.33 14.9 2.68 15.91 6.18",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path 314",
    d: "",
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path 314",
    d: "M16.22 0.5L16.22 6.22L10.55 5.51",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path 315",
    d: "",
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path 315",
    d: "M16.09 9.79C15.43 13.38 12.39 16.04 8.74 16.22C5.1 16.4 1.81 14.05 0.8 10.55",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path 316",
    d: "",
    fill: "#000000",
    fillOpacity: 0,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path 316",
    d: "M0.5 16.23L0.5 10.51L6.17 11.21",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableWhite);
export default __webpack_public_path__ + "static/media/available_white.bc510c3aff14202ecf9075964a3d42f3.svg";
export { ForwardRef as ReactComponent };